import { useReportTemplateContext } from '../ReportTemplate/ReportTemplateContext';

const YEAR_THRESHOLD = 1994;

const TEXT_BEFORE = `Kiinteistö on rakennettu ennen vuotta ${YEAR_THRESHOLD}, jolloin asbestia on voitu käyttää rakennusmateriaaleissa. Kohteessa on tällöin lakisääteinen tarve teettää asbestikartoitus ennen purkutöihin ryhtymistä.`;
const TEXT_AFTER  = `Kiinteistö on rakennettu vuoden ${YEAR_THRESHOLD} jälkeen, jolloin asbestia ei todennäköisesti ole käytetty rakennusmateriaaleissa. Lakisääteistä velvoitetta asbestikartoitukselle ei ole.`;

function extractYears(rakennusData, mergedRakennusData) {
  const src = mergedRakennusData || rakennusData;
  const firstMain = src?.rakennukset_fulls?.find(r => r.isMainBuilding);
  const raw = firstMain?.rakennusvuosi ?? src?.rakennusvuosi;
  if (!raw) return [];
  return String(raw).split(/[\s,;/\n]+/).map(v => parseInt(v, 10)).filter(v => !isNaN(v));
}

export default function AsbestBlock({ data, onChange }) {
  const { rakennusData, mergedRakennusData } = useReportTemplateContext();
  const years = extractYears(rakennusData, mergedRakennusData);
  const hasYear = years.length > 0;
  const earliestYear = hasYear ? Math.min(...years) : null;
  const isBefore = hasYear && earliestYear < YEAR_THRESHOLD;
  const yearLabel = years.join(' / ');
  const hiddenFromPdf = data?.hiddenFromPdf ?? false;

  const accentColor = !hasYear ? '#adb5bd' : isBefore ? '#e07b00' : '#198754';

  return (
    <div style={{ background: '#fff', border: '1px solid #dee2e6', borderLeft: `4px solid ${accentColor}`, borderRadius: 6, padding: '12px 16px' }}>
      <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
        <div className="d-flex align-items-center gap-2">
          <strong style={{ fontSize: '0.85rem', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Asbesti
          </strong>
          {hasYear && (
            <span style={{ color: accentColor, fontWeight: 600 }}>
              — rakennettu {yearLabel}
            </span>
          )}
        </div>
        <label className="d-flex align-items-center gap-1" style={{ fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}>
          <input
            type="checkbox"
            checked={hiddenFromPdf}
            onChange={e => onChange?.({ ...data, hiddenFromPdf: e.target.checked })}
            style={{ cursor: 'pointer' }}
          />
          Piilota PDF:stä
        </label>
      </div>
      <p className="mb-0" style={{ color: hiddenFromPdf ? '#adb5bd' : '#212529' }}>
        {hasYear
          ? (isBefore ? TEXT_BEFORE : TEXT_AFTER)
          : 'Kiinteistön rakennusvuosi ei ole tiedossa. Aseta rakennusvuosi kiinteistön perustiedoissa.'}
        {hasYear && years.length > 1 && (
          <span style={{ display: 'block', fontSize: '0.8rem', color: '#6c757d', marginTop: 4 }}>
            Asbestiarvio perustuu vanhimpaan rakennusvuoteen ({earliestYear}).
          </span>
        )}
      </p>
    </div>
  );
}
